import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [];

  initialize() {
    this.defaults = window.dataConfirmModal.setDefaults({
      title: 'Are you sure?',
      commit: 'Confirm',
      commitClass: 'btn btn--primary btn--raised',
      cancel: 'Cancel',
      cancelClass: 'btn btn--secondary btn--flat',
      fade: true,
      verifyClass: 'form-control',
      elements: [
        'a[data-confirm]',
        'button[data-confirm]',
        'input[type=submit][data-confirm]',
      ],
      focus: false,
      zIndex: 82000,
      modalClass: 'confirm',
      modalCloseContent: 'X',
      show: true,
    });
  }
}
